<div class="reconnect-window">
  <pinnakl-modal
    [hideDialog]="!reconnectWindowService.visible"
    [showCloseButton]="false"
    [width]="300"
    title="Reconnecting"
  >
    <div>
      Connection to the server was lost. Trying to re-establish connection..
      <div class="tw:text-center">
        <img
          alt=""
          class="tw:mt-4"
          src="/assets/images/spinner.gif"
        />
      </div>
    </div>
  </pinnakl-modal>
</div>
